export class Permissions {
    public static readonly jsonEditor = 'JSON Editor';
    public static readonly moduleAccessEdit = 'Module Access Editor';
    public static readonly copyConfig = 'Copy Config';
    public static readonly partialCopyConfig = 'Partial Copy Config';
    public static readonly piecewiseCopyConfig = 'Piecewise Copy Config';
    public static readonly cloneTenant = 'Clone Tenant';
    public static readonly tenantStatus = 'Tenant Status';
    public static readonly tenantType = 'Tenant Type';
    public static readonly tenantPermissionGroup = 'Tenant Permission Group';
    public static readonly tenantEcoTranslateSynchronisation = 'Tenant EcoTranslate Synchronisation';
    public static readonly matrixConfig = 'Matrix Config';
    public static readonly featureFlags = 'Feature Flags';
    public static readonly userGroupAdmin = 'User Group Admin';
    public static readonly formFlowPatchMigration = 'Form Flow Patch Migration';
    public static readonly editVersion = 'Edit Version';
    public static readonly admin = 'ADMIN';
    public static readonly maintenance = 'Maintenance';
    public static readonly removeData = 'Remove Data';
    public static readonly imports = 'Imports';
    public static readonly feeds = 'Feeds';
    public static readonly feedFileDownload = 'Feed File Download';
    public static readonly access = 'Access';
    public static readonly passportReadOnly = 'Passport Read Only';
    public static readonly deleteTenant = 'Delete Tenant';
    public static readonly migrationTool = 'Migration Tool';
    public static readonly tenantAttributes = 'Tenant Attributes';
    public static readonly freeTrialAdministration = 'Free Trial Administration';
}
